export default __webpack_public_path__ + "c957f14ac99dfa4f90a424a042a43e7b.png";